(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["miniout-review-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('miniout-review-carousel')) {
    class MinioutReviewCarousel extends HTMLElement {
      connectedCallback() {
        // Shopify may register this element before its child nodes have finished parsing.
        if (document.readyState === 'loading') {
          this._onDocumentReady = () => this.initialize();
          document.addEventListener('DOMContentLoaded', this._onDocumentReady, { once: true });
        } else {
          this.initialize();
        }
      }

      initialize() {
        if (this._initialized || !this.isConnected) return;
        const slides = Array.from(this.querySelectorAll('[data-review-slide]'));
        if (!slides.length) return;
        this._initialized = true;
        this.viewport = this.querySelector('[data-review-viewport]');
        this.track = this.querySelector('[data-review-track]');
        this.slides = slides;
        this.prev = this.querySelector('[data-review-prev]');
        this.next = this.querySelector('[data-review-next]');
        this.status = this.querySelector('[data-review-status]');
        this.index = 0;
        this._onPrev = () => this.show(this.index - 1);
        this._onNext = () => this.show(this.index + 1);
        this._onResize = () => this.updateHeight();
        if (this.prev) this.prev.addEventListener('click', this._onPrev);
        if (this.next) this.next.addEventListener('click', this._onNext);
        window.addEventListener('resize', this._onResize, { passive: true });

        if ('ResizeObserver' in window) {
          this._observer = new ResizeObserver(() => this.updateHeight());
          this.slides.forEach((slide) => this._observer.observe(slide));
        }

        this.show(0);
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => { if (this.isConnected) this.updateHeight(); });
        }
      }

      disconnectedCallback() {
        if (this._onDocumentReady) document.removeEventListener('DOMContentLoaded', this._onDocumentReady);
        if (this.prev) this.prev.removeEventListener('click', this._onPrev);
        if (this.next) this.next.removeEventListener('click', this._onNext);
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        if (this._observer) this._observer.disconnect();
        this._initialized = false;
      }

      updateHeight() {
        if (!this.viewport || !this.slides || !this.slides[this.index]) return;
        this.viewport.style.height = `${Math.ceil(this.slides[this.index].getBoundingClientRect().height)}px`;
      }

      show(index) {
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
        this.slides.forEach((slide, i) => {
          if (i === this.index) {
            slide.removeAttribute('aria-hidden');
            slide.removeAttribute('inert');
          } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('inert', '');
          }
        });
        if (this.prev) this.prev.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.slides.length - 1;
        if (this.status) this.status.textContent = `Review ${this.index + 1} of ${this.slides.length}`;
        this.updateHeight();
      }
    }
    customElements.define('miniout-review-carousel', MinioutReviewCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
